import { useFeatureFlags } from "@squide/firefly";
import { parseAsStringEnum, useQueryState } from "nuqs";
import { DEFAULT_TEAM_SCOPE, TEAM_SCOPES, type TeamScope } from "#shared/teamScope.ts";

const scopeParser = parseAsStringEnum<TeamScope>([...TEAM_SCOPES])
    .withDefault(DEFAULT_TEAM_SCOPE)
    .withOptions({ history: "replace", clearOnDefault: true, shallow: false });

export function useTeamScope() {
    const [scope, setScope] = useQueryState("team-scope", scopeParser);
    const { "navigation-redesign": isNavigationRedesign } = useFeatureFlags();
    const effectiveScope = isNavigationRedesign && scope === "organization" ? DEFAULT_TEAM_SCOPE : scope;

    return [effectiveScope, setScope] as const;
}
